import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppIcon } from '@app/shared/controls/app-icon/app-icon';
import { TranslatePipe } from '@ngx-translate/core';

type ChangeEmailModel = {
  email: string;
};

@Component({
  selector: 'app-change-email',
  imports: [AppIcon, FormsModule, TranslatePipe],
  templateUrl: './change-email.component.html',
  styleUrl: './change-email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeEmailComponent {
  readonly model = input.required<ChangeEmailModel>();
  readonly currentEmail = input<string>('');
  readonly update = output<void>();
  readonly cancelled = output<void>();

  protected onEmailChange(value: string): void {
    this.model().email = value;
  }
}

